module.exports = __webpack_public_path__ + "media/img/download_app_store_black-722b2db3.png";